.highlightedGrid {
  background-color: var(--mantine-color-gray-1);
  border-radius: 12px;
}
